export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-white/80">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-10 md:py-14">
        {/* Logo & Site Name */}
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
            <span className="text-white font-bold text-sm">O</span>
          </div>
          <span className="text-lg font-bold text-white">파주 헤이리 오베르원</span>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-8">
          {/* Site Info */}
          <div className="space-y-3 text-sm">
            <div className="flex items-start gap-2">
              <span className="text-white/50 w-20 flex-shrink-0">현장명</span>
              <span className="text-white/70">|</span>
              <span>파주 헤이리 오베르원</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-white/50 w-20 flex-shrink-0">홍보관</span>
              <span className="text-white/70">|</span>
              <span>경기도 파주시 다율동 1041-9 </span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-white/50 w-20 flex-shrink-0">관리자</span>
              <span className="text-white/70">|</span>
              <span>(주)애드탱크 010-4601-8729</span>
            </div>
          </div>

          {/* Call Info */}
          <div className="flex flex-col items-start md:items-end">
            <span className="text-white/50 text-sm mb-1">상담문의</span>
            <a
              href="tel:1877-4896"
              className="text-3xl md:text-4xl font-bold text-white hover:text-primary-300 transition-colors cursor-pointer"
            >
              1877-4896
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/10 mb-6" />

        {/* Notice */}
        <div className="text-xs text-white/40 leading-relaxed mb-6 space-y-1">
          <p>
            ※ 본 홈페이지에 사용된 투시도, 조감도, CG, 이미지 및 내용, 문구 등은
            소비자의 이해를 돕기 위해 제작 또는 표현된 것으로 실제와 차이가 있을
            수 있습니다.
          </p>
          <p>
            ※ 본 홈페이지 상의 개발 및 교통계획에 대한 사항은 추후 관계기관의
            사정에 따라 변경 및 취소 될 수 있으며, 이는 당사와 무관함을
            알려드립니다.
          </p>
          <p>
            ※ 본 홈페이지의 내용은 시행사 및 시공사 및 관계기관에 의해 변경될 수
            있습니다.
          </p>
        </div>

        {/* Copyright */}
        <div className="text-center text-xs text-white/30">
          Copyright 2026 CO.,LTD. ALL RIGHTS RESERVED.
        </div>
      </div>
    </footer>
  );
}
